// frontend/src/features/landingPages/components/SectionPalette.js
import React from 'react';
import { SECTION_TYPES } from '../sectionCatalog';

/**
 * Palette of section blocks the author can add to the landing-page outline.
 * Rendered as a sleek, modern horizontal quick-add ribbon across the top of the outline builder.
 */
export default function SectionPalette({ onAddSection, disabled = false }) {
  return (
    <div className="lp-quick-add-shelf" aria-label="Section blocks">
      <div className="lp-quick-add-badge">
        <i className="fas fa-plus" aria-hidden="true"></i>
        <span>Add block</span>
      </div>
      <div className="lp-quick-add-pills" role="toolbar" aria-label="Add section blocks">
        {SECTION_TYPES.map((def) => (
          <button
            key={def.type}
            type="button"
            className="lp-quick-add-pill"
            onClick={() => onAddSection(def.type)}
            disabled={disabled}
            title={def.description}
          >
            <span className="lp-quick-add-pill-icon" aria-hidden="true">
              <i className={def.icon}></i>
            </span>
            <span className="lp-quick-add-pill-label">{def.label}</span>
            <span className="lp-quick-add-pill-plus" aria-hidden="true">
              <i className="fas fa-plus"></i>
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
